import React, { useContext } from "react";
import { AppContext, DispatchContext } from "../../AppContext";
import SearchIcon from "@material-ui/icons/Search";
import GroupIcon from '@material-ui/icons/Group';
import DashboardIcon from "@material-ui/icons/Dashboard";
import AddIcon from "@material-ui/icons/Add";
import BuildIcon from "@material-ui/icons/Build";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import FolderOpenOutlinedIcon from "@material-ui/icons/FolderOpenOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import { makeStyles } from "@material-ui/styles";
import * as actions from "../../actions/actions";

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'

import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import PieChartIcon from '@material-ui/icons/PieChart';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

import { config } from '../../helpers/constants';
import madeInGermany from '../../assets/made-in-germany-logo.png';


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: "0 0 auto",
    flexDirection: "column",
    width: (state) => {
      return state.ui.leftPanelVisible ? 275 : 55;
    },
    maxWidth: 275,
    transition: "width 0.4s",
    zIndex: 8,
    boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#272D37",
    color: '#eeeeee',
  },
  appMenu: {
    overflowY: "auto",
    overflowX: "hidden",
    flex: '1 1 auto'
  },
  menuItem: {
    padding: "5px 15px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    }
  },
  menuItemIcon: {
    minWidth: "40px",
    color: '#eeeeee',
  },
  subMenuItemIcon: {
    minWidth: "40px",
    color: '#BCDBF6',
  },
  typoGraphyIcon: {
    transition: "margin 0.4s",
    margin: (state) => {
      return state.ui.leftPanelVisible ? "0 0 0 30px" : 0;
    },
    color: '#BCDBF6'
  },
  contentText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    transition: 'opacity 0.4s',
    opacity: (state) => {
      return state.ui.leftPanelVisible ? 1 : 0;
    }

  },
  bottom: {
    paddingBottom: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  activeMenu: {
    textDecoration: "none",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    padding: "5px 15px",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.3)",
    }
  }
}));

export default function LeftBar(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);

  const handleNewCheck = () => {
    dispatch(actions.setNewCheckSettings({ revisionReportId: null }));
    dispatch(actions.navigate_to("/plagiarism/new"));
  }

  const onNavigateToBackendUrl = (url) => {
    window.location.href = config.backendUrl + url;
  }

  return (
    <div className={classes.root}>
      <List component="nav" className={classes.appMenu} disablePadding>
        <ListItem button={true} className={state.ui.pageName === '/dashboard' ? classes.activeMenu : classes.menuItem} onClick={() => dispatch(actions.navigate_to("/dashboard"))}>
          <ListItemIcon className={classes.menuItemIcon}>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText className={classes.contentText} primary={s.menu.dashboard} />
        </ListItem>

        <ListItem button={true} onClick={() => dispatch(actions.setUI({ plagCheckMenuExpanded: !state.ui.plagCheckMenuExpanded }))} className={state.ui.pageName.includes('/plagiarism') ? classes.activeMenu : classes.menuItem}>
          <ListItemIcon className={classes.menuItemIcon}>
            <SearchIcon />
          </ListItemIcon>
          <ListItemText className={classes.contentText} primary={s.plagiarism} />
          {state.ui.leftPanelVisible ?
            state.ui.plagCheckMenuExpanded ? <IconExpandLess /> : <IconExpandMore />
            : null
          }
        </ListItem>
        <Collapse in={state.ui.plagCheckMenuExpanded} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            <ListItem button={true} className={`${classes.typoGraphyIcon} ${state.ui.pageName === '/plagiarism/new' ? classes.activeMenu : classes.menuItem}`} onClick={handleNewCheck}>
              <ListItemIcon className={classes.subMenuItemIcon}>
                <AddIcon />
              </ListItemIcon>
              <ListItemText className={classes.contentText} primary={s.new} />
            </ListItem>
            <ListItem button={true} className={`${classes.typoGraphyIcon} ${state.ui.pageName === '/plagiarism/reports' ? classes.activeMenu : classes.menuItem}`} onClick={() => dispatch(actions.navigate_to("/plagiarism/reports"))}>
              <ListItemIcon className={classes.subMenuItemIcon}>
                <FormatListBulletedIcon />
              </ListItemIcon>
              <ListItemText className={classes.contentText} primary={s.performedChecks} />
            </ListItem>
            <ListItem button={true} className={`${classes.typoGraphyIcon} ${state.ui.pageName === '/plagiarism/reports/' + state.activeReportId ? classes.activeMenu : classes.menuItem}`} onClick={() => dispatch(actions.navigate_to(`/plagiarism/reports/${state.activeReportId || ''}`))}>
              <ListItemIcon className={classes.subMenuItemIcon}>
                <PieChartIcon />
              </ListItemIcon>
              <ListItemText className={classes.contentText} primary={s.review} />
            </ListItem>
          </List>
        </Collapse>
        { state.user.settings.useTextMonitoring && 
        <ListItem button={true} onClick={() => dispatch(actions.setUI({ monitoringMenuExpanded: !state.ui.monitoringMenuExpanded }))} className={state.ui.pageName === '/textmonitoring' ? classes.activeMenu : classes.menuItem} onClick={() => onNavigateToBackendUrl((state.lang == "de") ? "de/textueberwachung/monitoredtexts" : "text-monitoring/monitoredtexts")}>
          <ListItemIcon className={classes.menuItemIcon}>
            <VisibilityOutlinedIcon />
          </ListItemIcon>
          <ListItemText className={classes.contentText} primary={s.textMonitoring} />
        </ListItem>}
        
        {state.user.license && !(state.user.license.beginnerMode) &&  
        <ListItem button={true} onClick={() => dispatch(actions.setUI({ toolsMenuExpanded: !state.ui.toolsMenuExpanded }))} className={state.ui.pageName === '/tools' ? classes.activeMenu : classes.menuItem}>
          <ListItemIcon className={classes.menuItemIcon}>
            <BuildIcon />
          </ListItemIcon>
          <ListItemText className={classes.contentText} primary={s.tools} />
          {state.ui.leftPanelVisible ?
            state.ui.toolsMenuExpanded ? <IconExpandLess /> : <IconExpandMore />
            : null
          }
        </ListItem>}
        
        {state.user.license && !(state.user.license.beginnerMode) && 
        <Collapse in={state.ui.toolsMenuExpanded} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            <ListItem button={true} className={`${classes.typoGraphyIcon} ${state.ui.pageName === '/tools/comparisons' ? classes.activeMenu : classes.menuItem}`} onClick={() => dispatch(actions.navigate_to('/tools/comparisons'))}>
              <ListItemIcon className={classes.subMenuItemIcon}>
                <BubbleChartIcon />
              </ListItemIcon>
              <ListItemText className={classes.contentText} primary={s.menu.textComparisons} />
            </ListItem>
          </List>
        </Collapse>
        }



        <ListItem button={true} onClick={() => dispatch(actions.setUI({ libraryMenuExpanded: !state.ui.libraryMenuExpanded }))} className={state.ui.pageName.includes('/library') ? classes.activeMenu : classes.menuItem}>
          <ListItemIcon className={classes.menuItemIcon}>
            <LibraryBooksIcon />
          </ListItemIcon>
          <ListItemText className={classes.contentText} primary={s.library} />
          {state.ui.leftPanelVisible ?
            state.ui.libraryMenuExpanded ? <IconExpandLess /> : <IconExpandMore />
            : null
          }
        </ListItem>
        <Collapse in={state.ui.libraryMenuExpanded} timeout="auto" unmountOnExit>
          <Divider />
          <List component="div" disablePadding>
            <ListItem button={true} className={`${classes.typoGraphyIcon} ${state.ui.pageName === '/library/new' ? classes.activeMenu : classes.menuItem}`} onClick={() => dispatch(actions.navigate_to("/library/new"))}>
              <ListItemIcon className={classes.subMenuItemIcon}>
                <AddIcon />
              </ListItemIcon>
              <ListItemText className={classes.contentText} primary={s.menu.newText} />
            </ListItem>
            <ListItem button={true} className={`${classes.typoGraphyIcon} ${state.ui.pageName === '/library/overview' ? classes.activeMenu : classes.menuItem}`} onClick={() => dispatch(actions.navigate_to("/library/overview"))}>
              <ListItemIcon className={classes.subMenuItemIcon}>
                <FormatListBulletedIcon />
              </ListItemIcon>
              <ListItemText className={classes.contentText} primary={s.menu.libtexts} />
            </ListItem>
          </List>
        </Collapse>

        <ListItem button={true} className={state.ui.pageName === '/projects' ? classes.activeMenu : classes.menuItem} onClick={() => dispatch(actions.navigate_to("/projects"))}>
          <ListItemIcon className={classes.menuItemIcon}>
            <FolderOpenOutlinedIcon />
          </ListItemIcon>
          <ListItemText className={classes.contentText} primary={s.menu.projects} />
        </ListItem>
        {state.user.userId == state.user.license.adminUserId &&
          <ListItem button={true} className={state.ui.pageName === '/license' ? classes.activeMenu : classes.menuItem} onClick={() => dispatch(actions.navigate_to("/license"))}>
            <ListItemIcon className={classes.menuItemIcon}>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText className={classes.contentText} primary={s.menu.license} />
          </ListItem>
        }
        {state.user.status == "Admin" &&
          <ListItem className={state.ui.pageName === '/pa-admin' ? classes.activeMenu : classes.menuItem} button={true} onClick={() => onNavigateToBackendUrl((state.lang == "de") ? "de/pa-admin" : "pa-admin")} >
            <ListItemIcon className={classes.menuItemIcon}>
              <VpnKeyIcon />
            </ListItemIcon>
            <ListItemText className={classes.contentText} primary="Admin" />
          </ListItem>
        }



      </List>
      <div className={classes.bottom}>
        {state.ui.leftPanelVisible && <>
          <img style={{ width: "50%", maxWidth: 125, height: 20 }} src={madeInGermany} alt="logo" />
          <div style={{ fontSize: 10, color: '#888', marginTop: 4 }}>
            {(() => { const meta = document.querySelector('meta[name="version"]'); return meta ? 'v' + meta.getAttribute('content') : ''; })()}
          </div>
          <div style={{ fontSize: 10, color: '#888', marginTop: 4, textAlign: 'center', lineHeight: '1.8' }}>
            <a href={config.backendUrl + s.copyright.dataProtectionUrl} style={{ color: '#888', textDecoration: 'none' }}>{s.copyright.dataProtectionPolicy}</a>
            {' · '}
            <a href={config.backendUrl + s.copyright.imprintUrl} style={{ color: '#888', textDecoration: 'none' }}>{s.copyright.imprint}</a>
            {' · '}
            <a href={config.backendUrl + s.copyright.termsOfUseUrl} style={{ color: '#888', textDecoration: 'none' }}>{s.copyright.termsOfUse}</a>
            {' · '}
            <a href="#" style={{ color: '#1565C0', textDecoration: 'none', fontWeight: 'bold' }} onClick={(e) => { e.preventDefault(); dispatch(actions.navigate_to('/revoke')); }}>{s.copyright.revokeContract}</a>
          </div>
        </>}
      </div>
    </div>
  );
}
